import { render } from "./Barns.vue?vue&type=template&id=fad32b08&ts=true"
import script from "./Barns.vue?vue&type=script&lang=ts"
export * from "./Barns.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__